import { render, staticRenderFns } from "./RotatingGroupsExtension.vue?vue&type=template&id=708ec6f2&scoped=true"
import script from "./RotatingGroupsExtension.vue?vue&type=script&lang=js"
export * from "./RotatingGroupsExtension.vue?vue&type=script&lang=js"
import style0 from "./RotatingGroupsExtension.vue?vue&type=style&index=0&id=708ec6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ec6f2",
  null
  
)

export default component.exports